var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "85.5334 2.6793 505.502 505.8412",
      "width": "200",
      "height": "200"
    }
  }, [_c('circle', {
    staticStyle: {
      "fill": "rgb(33, 150, 243)",
      "stroke-width": "0.312"
    },
    attrs: {
      "cx": "-1191",
      "cy": "-660.24",
      "r": "252.751",
      "transform": "matrix(1, 0, 0, 1.0006710290908813, 1529.284423828125, 916.2828979492189)"
    }
  }), _c('path', {
    staticStyle: {
      "fill": "rgb(30, 127, 206)",
      "stroke-width": "0.248"
    },
    attrs: {
      "d": "M 581.854 323.449 L 350.213 91.661 L 328.586 308.201 L 291.702 416.919 L 379.838 505.101 C 477.251 488.994 555.859 417.178 581.854 323.449 Z",
      "transform": "matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "rgb(147, 86, 53)",
      "stroke-width": "0.248"
    },
    attrs: {
      "x": "326.453",
      "y": "91.661",
      "width": "23.829",
      "height": "28.102",
      "transform": "matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "rgb(128, 64, 0)",
      "stroke-width": "0.248"
    },
    attrs: {
      "x": "338.282",
      "y": "91.661",
      "width": "11.914",
      "height": "28.102",
      "transform": "matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
    }
  }), _c('path', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(51, 76, 94)"
    },
    attrs: {
      "d": "M 352.364 168.31 L 352.364 114.258 L 324.295 114.258 L 324.295 168.31 C 324.295 188.484 317.747 208.117 305.667 224.255 L 300.78 230.731 C 288.651 246.874 282.177 266.505 282.177 286.678 L 282.177 395.541 C 282.177 411.376 294.976 424.21 310.826 424.21 L 365.821 424.21 C 381.676 424.21 394.448 411.373 394.448 395.541 L 394.448 286.681 C 394.448 266.505 387.969 246.874 375.881 230.731 L 370.992 224.257 C 358.905 208.117 352.364 188.486 352.364 168.31 Z",
      "transform": "matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
    }
  }), _c('path', {
    staticStyle: {
      "stroke-width": "0.248",
      "fill": "rgb(42, 59, 80)"
    },
    attrs: {
      "d": "M 375.881 230.731 L 370.992 224.257 C 358.905 208.122 352.364 188.484 352.364 168.31 L 352.364 114.258 L 338.282 114.258 L 338.282 424.213 L 365.821 424.213 C 381.676 424.213 394.448 411.376 394.448 395.541 L 394.448 286.681 C 394.448 266.505 387.969 246.874 375.881 230.731 Z",
      "transform": "matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "rgb(252, 111, 88)",
      "stroke-width": "0.248"
    },
    attrs: {
      "x": "296.191",
      "y": "283.702",
      "width": "84.25",
      "height": "84.307",
      "transform": "matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
    }
  }), _c('rect', {
    staticStyle: {
      "fill": "rgb(241, 84, 63)",
      "stroke-width": "0.248"
    },
    attrs: {
      "x": "338.282",
      "y": "283.702",
      "width": "42.126",
      "height": "84.307",
      "transform": "matrix(1, 0, 0, 1, 0, 1.4210854715202004e-14)"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }